import styled, { css } from 'styled-components'

export const Label = styled.label(
  ({ theme, focused, disabled, error }) => css`
    position: absolute;
    left: 24px;
    top: -8px;

    color: ${theme.colors.grays.N500};
    background-color: #fff;
    padding: 0 8px;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.label};
    font-weight: ${theme.fontWeights.extraBold};

    transition: color 0.2s;

    ${focused && `color: ${theme.colors.primary}`}
    ${disabled && `color: ${theme.colors.grays.N300}`}
    ${error && `color: ${theme.colors.error}`}
  `,
)

export const ErrorText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.fontSizes[0]};
    line-height: 1em;
    position: absolute;
    bottom: -18px;
  `,
)
